import { Toast } from "@al/akui-mobile";
import { CtxType } from "@al/next/al-ex";
import qs from "qs";

import { logout } from "~/global/redux/sign/helper";

import { NO_LOGIN_ROUTER } from "../constants";

export default async function unauthorizedToLogin(ctx: CtxType): Promise<boolean> {
  const { asPath } = ctx.router;
  const countryCode = ctx.locale.countryCode;
  if (!countryCode || NO_LOGIN_ROUTER.includes(ctx.router.pathname)) {
    return false;
  }
  const pathname = `${asPath}`.split("?")[0];

  // 去掉 countryCode
  const query = {
    ...ctx.router.query,
    countryCode: undefined,
  };
  delete query.countryCode;

  const queryLength = Object.keys(query).length;

  const retureUrl = encodeURIComponent(`${pathname}${queryLength > 0 ? "?" : ""}${qs.stringify(query)}`);

  ctx.store.dispatch((ctx.actions as any).sign.clearSignState());
  ctx.store.dispatch(logout());
  const isFromOP = ctx.router?.query?.from === "OP" || ctx.router?.query?.brand === "2";
  const OPLoginUrl = `https://${process.env.BUILD_ENV === "prod" ? "" : "test-"}pay.silvrr.com/signin/email`;
  if (process.server) {
    ctx.res?.redirect(isFromOP ? OPLoginUrl : `/mobile/user/login?return_url=${retureUrl}`);
  } else {
    if (ctx.router.query.countryCode) {
      await ctx.router.replace(
        {
          pathname,
          query,
        },
        undefined,
        { shallow: true }
      );
    }
    ctx.router.push({
      pathname: isFromOP ? OPLoginUrl : "/user/login",
      query: {
        return_url: `${retureUrl}`,
      },
    });
    Toast.show({ content: ctx.i18n.t("global:账号掉线，请重新登录") });
  }
  return true;
}
